import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';
import { hideRectangle, revealRectangle } from '../../../../util/animation/reveal/reveal';
import { slideHorizontally, slideOut, slideUp } from '../../../../util/animation/slide/slide';

interface LocaleListRefs {
  elementRef: RefObject<HTMLElement | null>;
  listRef: RefObject<HTMLUListElement | null>;
  isMobileViewport: boolean;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, listRef, isMobileViewport }: LocaleListRefs,
): void {
  timeline.add(
    revealRectangle(elementRef.current as HTMLElement, {
      from: isMobileViewport ? 'right' : 'top',
      duration: 0.8,
      ease: 'Power2.easeOut',
    }),
  );
  timeline.add(fadeFromTo(listRef.current as HTMLElement), 0);
  if (isMobileViewport) {
    timeline.add(slideHorizontally(listRef.current as HTMLElement, { from: 100, to: 0 }), 0);
  } else {
    timeline.add(slideUp(listRef.current as HTMLElement, { from: -100, to: 0 }), 0);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, listRef, isMobileViewport }: LocaleListRefs,
): void {
  timeline.add(
    hideRectangle(elementRef.current as HTMLElement, {
      to: isMobileViewport ? 'right' : 'bottom',
    }),
    0,
  );
  timeline.add(fadeTo(listRef.current as HTMLElement), 0);
  if (isMobileViewport) {
    timeline.add(slideHorizontally(listRef.current as HTMLElement, { from: 0, to: 100 }), 0);
  } else {
    timeline.add(slideOut(listRef.current as HTMLElement, { to: 100 }), 0);
  }
}
